import useDataFetcher from '~/components/useDataFetcher';
import type { HolidaySubdivisionsResponse } from '~/server_shared/openapi/data-contracts';

import type { HolidaySubdivision } from './types';

export interface HolidaySubdivisionsState {
  territory?: string;
  subdivisions: HolidaySubdivision[];
  isLoading: boolean;
  isError: boolean;
}

// Server-supplied on purpose: the valid codes are whatever the `holidays` package accepts on write,
// so a list hardcoded here would drift out of agreement with the validator on the next upgrade.
// `localeOverride` previews the options for a locale the user has picked but not yet saved.
export function useHolidaySubdivisions(organizationId: number, localeOverride?: string): HolidaySubdivisionsState {
  const { data, isLoading, isError } = useDataFetcher<HolidaySubdivisionsResponse>(
    `/sysconfig/api/v1/organizations/${organizationId}/holiday_subdivisions`,
    {
      params: localeOverride ? { locale: localeOverride } : {},
    }
  );

  // `isError` is passed through rather than swallowed: a failed fetch leaves `data` undefined, which
  // is indistinguishable from "this territory has no subdivisions" unless the caller can tell the
  // two apart — and one of them must not be treated as a reason to clear a stored code.
  return { territory: data?.territory, subdivisions: data?.subdivisions || [], isLoading, isError };
}
